/**
 * Varlık sunucularına erken bağlantı (`<link rel="preconnect">`).
 *
 * Kaynak-referans bunu HTML şablonunda yapar (`{{MEDIA_ENDPOINT}}`, `{{STATIC_CDN_ENDPOINT}}` yer
 * tutucularını sunucu doldurur). TEBHOS şablonu statiktir ve uç noktalar derleme ortamından
 * (`NEXT_PUBLIC_*`) gelir; bu yüzden aynı bağlantılar giriş modülünün İLK işi olarak, ilk görsel
 * isteğinden önce eklenir. Avatar/emoji/ek görselleri API kökünden, mağaza videoları CDN'den iner:
 * DNS + TLS el sıkışması ilk görsel isteğini beklemez.
 *
 * Aynı kökten sunulan (geliştirme: göreli `/api/v1`) uç için bağlantı zaten açıktır → eklenmez.
 * CDN iki kez eklenir: `<img>`/`<video>` kimlik bilgili, yazı tipi/`fetch` anonim bağlantı havuzunu
 * kullanır ve tarayıcı bunları ayrı tutar (kaynak-referans şablonu da iki satır taşır).
 */

import { RuntimeConfig } from "@/lib/config/RuntimeConfig";

function originOf(value: string | undefined | null): string | null {
  if (!value || value.startsWith("/")) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" || url.protocol === "http:" ? url.origin : null;
  } catch {
    return null;
  }
}

function appendPreconnect(origin: string, crossOrigin: boolean): void {
  const selector = `link[rel="preconnect"][href="${origin}"]${crossOrigin ? "[crossorigin]" : ":not([crossorigin])"}`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = origin;
  if (crossOrigin) link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

export function installAssetPreconnects(): void {
  if (typeof document === "undefined" || typeof window === "undefined") return;
  const own = window.location.origin;
  const api = originOf(RuntimeConfig.apiBase);
  const cdn = originOf(RuntimeConfig.cdnUrl) ?? originOf(process.env.NEXT_PUBLIC_ASSET_CDN);
  if (cdn && cdn !== own) {
    appendPreconnect(cdn, false);
    appendPreconnect(cdn, true);
  }
  if (api && api !== own) appendPreconnect(api, false);
}
